import { hasUnfilledCustomFields } from '@/components/profile/CustomFieldsUtils'

export const actionsCustomFields = {
    async fetchHasUnfilledCustomFieldsAction({ commit }, { userId, studioId }) {
        const result = await hasUnfilledCustomFields(userId, studioId)
        commit('setHasUnfilledCustomFields', result)
    },
}
